module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('h1', {
    staticClass: "text-primary"
  }, [_vm._v("Categories")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "type": "info",
      "title": "Caution!",
      "description": "Changing contents here has far reaching consquences on the data, please make sure your changes won't affect existing data.",
      "show-icon": "",
      "closable": false
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "name": "actions"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Actions "), _c('i', {
    staticClass: "header-icon fa fa-asterisk"
  })])]), _vm._v(" "), _c('coming-soon')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "sites"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Sites "), _c('i', {
    staticClass: "header-icon fa fa-stopwatch"
  })])]), _vm._v(" "), _c('coming-soon')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "maint"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Projects & Maintenance "), _c('i', {
    staticClass: "header-icon fa fa-wrench"
  })])]), _vm._v(" "), _c('coming-soon')], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "property"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "text-info"
  }, [_vm._v("Property "), _c('i', {
    staticClass: "header-icon fa fa-home"
  })])]), _vm._v(" "), _c('coming-soon')], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1227a2e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Categories.vue
// module id = 1428
// module chunks = 0